export default __webpack_public_path__ + "static/media/measureUpFemale.6f0eaf2b.png";